/**
 * Configuration globale du site
 * Centralise toutes les références au domaine pour éviter les duplications
 */
export const SITE_CONFIG = {
  domain: 'https://coolorfool.eu',
  name: 'Coolorfool',
  email: 'service-client@coolorfool.eu',
  adminEmail: 'admin@coolorfool.eu',
  privacyEmail: 'privacy@coolorfool.eu',
  serviceEmail: 'service-client@coolorfool.eu',
  social: {
    instagram: 'https://www.instagram.com/coolorfool',
    facebook: 'https://www.facebook.com/coolorfool',
  },
} as const;

/**
 * Helper pour construire une URL complète
 */
export const buildUrl = (path: string, language?: string): string => {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  if (language && language !== 'fr') {
    return `${SITE_CONFIG.domain}/${language}${cleanPath}`;
  }
  return `${SITE_CONFIG.domain}${cleanPath}`;
};

/**
 * Helper pour construire une URL avec préfixe langue optionnel
 */
export const buildLocalizedUrl = (path: string, language: string): string => {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  const langPrefix = language === 'fr' ? '' : `${language}/`;
  return `${SITE_CONFIG.domain}/${langPrefix}${cleanPath.replace(/^\//, '')}`;
};
